import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { selfserviceOrders } from "../../redux/actions";

const ActiveOrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [archiveorders, archivesetOrders] = useState([]);
  const [error, setError] = useState(null);
  const [orderType, setOrderType] = useState("active"); // Default type is "active"
  // Fetch orders whenever orderType changes
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const data = await selfserviceOrders(orderType);
        if (orderType === "active") {
          setOrders(data?.data || []); // Ensure orders exist
        } else {
          archivesetOrders(data?.data || []); // Ensure orders exist
        }
      } catch (err) {
        setError(err.message);
      }
    };

    fetchOrders();
  }, [orderType]); // Runs when orderType changes

  const navigate = useNavigate();

  const handleRedirect = (id) => {
    navigate("/self-service/track-orders", { state: { action: id } }); // Pass the id in the URL
  };

  // Pagination for active orders
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 5;
  const totalPages = Math.ceil(orders.length / ordersPerPage);

  const currentOrders = orders.slice(
    (currentPage - 1) * ordersPerPage,
    currentPage * ordersPerPage
  );

  const getPageNumbers = () => {
    if (totalPages <= 3) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    if (currentPage <= 2) {
      return [1, 2, 3];
    }
    if (currentPage >= totalPages - 1) {
      return [totalPages - 2, totalPages - 1, totalPages];
    }
    return [currentPage - 1, currentPage, currentPage + 1];
  };

  // Pagination for archive orders
  const [currentArchivePage, setCurrentArchivePage] = useState(1);
  const archiveOrdersPerPage = 5; // same as ordersPerPage or change as needed
  const archiveTotalPages = Math.ceil(
    archiveorders.length / archiveOrdersPerPage
  );
  const currentArchiveOrders = archiveorders.slice(
    (currentArchivePage - 1) * archiveOrdersPerPage,
    currentArchivePage * archiveOrdersPerPage
  );

  const getArchivePageNumbers = () => {
    if (archiveTotalPages <= 3) {
      return Array.from({ length: archiveTotalPages }, (_, i) => i + 1);
    }
    if (currentArchivePage <= 2) {
      return [1, 2, 3];
    }
    if (currentArchivePage >= archiveTotalPages - 1) {
      return [archiveTotalPages - 2, archiveTotalPages - 1, archiveTotalPages];
    }
    return [currentArchivePage - 1, currentArchivePage, currentArchivePage + 1];
  };

  return (
    <section className="hot-deals pt-20">
      {/* component 1 about us*/}
      <div className="container container-lg">
        <div className="section-heading">
          <div className="flex-between flex-wrap gap-8">
            <h2 className="mb-0 text-blue">MY ORDERS</h2>
          </div>
        </div>
      </div>

      <div className="container container-lg ">
        <ul className="nav common-tab nav-pills" id="pills-tab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link   ${orderType === "active" ? "active" : ""}`}
              onClick={() => setOrderType("active")}
              id="pills-all-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-all"
              type="button"
              role="tab"
              aria-controls="pills-all"
              aria-selected="true"
            >
              Active orders
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${orderType === "archive" ? "active" : ""}`}
              onClick={() => setOrderType("archive")}
              id="pills-grocery-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-grocery"
              type="button"
              role="tab"
              aria-controls="pills-grocery"
              aria-selected="false"
            >
              Order archive
            </button>
          </li>
        </ul>
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-all"
            role="tabpanel"
            aria-labelledby="pills-all-tab"
            tabIndex={0}
          >
            <div className="container container-lg ">
              <div className="row gy-4">
                {/* grid for orders */}
                <div>
                  <div className="col-sm-12">
                    {orders.length === 0 && (
                      <p>There are no orders to display yet!</p>
                    )}
                    {orders.length > 0 &&
                      currentOrders.map((data, index) => (
                        <React.Fragment key={index}>
                          <div className="border border-gray-100 hover:border-main-600 rounded-16 position-relative transition-2 offer-card overflow-hidden p-16">
                            <div className="py-xl">
                              <div>
                                <div className="d-flex justify-content-between align-items-center w-100 p-2 gap-2">
                                  <span className="text-sm text-white">
                                    <h4 className="text-blue">
                                      <b>
                                        Order{" "}
                                        {new Date(data?.created_at)
                                          .toLocaleDateString("en-GB")
                                          .replace(/\//g, ".")}
                                      </b>
                                    </h4>
                                    <p className="text-black">
                                      {`Order #${
                                        data?.id < 1000
                                          ? String(data?.id).padStart(4, "0")
                                          : "0" + data?.id
                                      }`}{" "}
                                      | {data?.currency?.value}{" "}
                                      {data?.total_gross_price?.toFixed(
                                        data?.currency?.value === "OMR" ? 3 : 2
                                      )}{" "}
                                      | {data?.order_products_count} items
                                    </p>
                                    <p className="text-black">
                                      Delivery to {data?.location?.name}
                                    </p>
                                  </span>
                                  <span className="text-sm text-main-two-600">
                                    <button
                                      className="btn bg-main-product-50 hover-bg-main-product-50 d-inline-flex align-items-center gap-8"
                                      type="button"
                                      onClick={() => handleRedirect(data.id)}
                                    >
                                      View order
                                    </button>
                                  </span>
                                </div>
                                <hr />
                                <div className="d-flex flex-wrap flex-md-nowrap w-100 gap-2 order-container">
                                  <div className="d-flex justify-content-between align-items-center w-100 w-md-50 p-16 bg-light-grey mb-32">
                                    <span className="text-sm text-white">
                                      <p className="text-black">Order Status</p>
                                      <p className="text-black">
                                        <b>
                                          Ordered{" "}
                                          {new Date(data?.created_at)
                                            .toLocaleDateString("en-GB")
                                            .replace(/\//g, ".")}
                                        </b>
                                      </p>
                                    </span>
                                    <span className="text-sm text-main-two-600">
                                      <p className="text-black">
                                        Preferred delivery date
                                      </p>
                                      <p className="text-black">
                                        {data?.preferred_delivery_date
                                          ? new Date(
                                              data.preferred_delivery_date
                                            )
                                              .toLocaleDateString("en-GB")
                                              .replace(/\//g, ".")
                                          : "-"}
                                      </p>
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center w-100 w-md-50 p-16 bg-light-grey mb-32">
                                    <span className="text-sm text-white">
                                      <p className="text-black">
                                        Payment status
                                      </p>
                                      <p className="text-black">
                                        <b>{data?.payment_status}</b>
                                      </p>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <br />
                        </React.Fragment>
                      ))}
                  </div>

                  {/* Pagination Controls */}
                  {totalPages > 1 && (
                    <div className="d-flex justify-content-center align-items-center mt-4">
                      <button
                        style={{
                          backgroundColor:
                            currentPage > 1 ? "#1d3c73" : "#4887c7",
                          color: "white",
                          padding: "0.5rem 1rem",
                          borderRadius: "0.25rem",
                          border: "none",
                          transition: "background-color 0.3s",
                        }}
                        onMouseEnter={(e) =>
                          (e.target.style.backgroundColor = "#1d3c73")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.backgroundColor = "#4887c7")
                        }
                        className="mx-1"
                        onClick={() =>
                          currentPage > 1 && setCurrentPage(currentPage - 1)
                        }
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>

                      {getPageNumbers().map((page, idx) => {
                        const isActive = page === currentPage;
                        return (
                          <button
                            key={idx}
                            style={{
                              backgroundColor: isActive ? "#1d3c73" : "#4887c7",
                              color: "white",
                              padding: "0.5rem 1rem",
                              borderRadius: "0.25rem",
                              border: "none",
                              transition: "background-color 0.3s",
                            }}
                            // Only add hover effects if not active
                            onMouseEnter={
                              !isActive
                                ? (e) =>
                                    (e.target.style.backgroundColor = "#1d3c73")
                                : undefined
                            }
                            onMouseLeave={
                              !isActive
                                ? (e) =>
                                    (e.target.style.backgroundColor = "#4887c7")
                                : undefined
                            }
                            className="mx-1"
                            onClick={() => setCurrentPage(page)}
                          >
                            {page}
                          </button>
                        );
                      })}

                      <button
                        style={{
                          backgroundColor:
                            currentPage < totalPages ? "#1d3c73" : "#4887c7",
                          color: "white",
                          padding: "0.5rem 1rem",
                          borderRadius: "0.25rem",
                          border: "none",
                          transition: "background-color 0.3s",
                        }}
                        onMouseEnter={(e) =>
                          (e.target.style.backgroundColor = "#1d3c73")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.backgroundColor = "#4887c7")
                        }
                        className="mx-1"
                        onClick={() =>
                          currentPage < totalPages &&
                          setCurrentPage(currentPage + 1)
                        }
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div
            className="tab-pane fade"
            id="pills-grocery"
            role="tabpanel"
            aria-labelledby="pills-grocery-tab"
            tabIndex={0}
          >
            <div className="container container-lg ">
              <div className="row gy-4">
                {/* grid for orders */}
                <div className="col-sm-12 ">
                  {archiveorders.length === 0 && (
                    <>
                      <br></br>
                      <p>There are no orders to display yet!</p>
                    </>
                  )}
                  {archiveorders &&
                    archiveorders.length > 0 &&
                    currentArchiveOrders.map((data, index) => (
                      <>
                        {" "}
                        {/* React Fragment */}
                        <div
                          key={index}
                          className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16"
                        >
                          <div className="py-xl">
                            <div>
                              <div className="flex-align gap-8 d-flex justify-content-between w-100 p-2">
                                <span className="text-sm text-white">
                                  <h4 className="text-blue">
                                    <b>
                                      Order{" "}
                                      {new Date(data?.created_at)
                                        .toLocaleDateString("en-GB")
                                        .replace(/\//g, ".")}
                                    </b>
                                  </h4>
                                  <p className="text-black">
                                    {`Order #${
                                      data?.id < 1000
                                        ? String(data?.id).padStart(4, "0")
                                        : "0" + data?.id
                                    }`}{" "}
                                    | {data?.currency?.value}{" "}
                                    {data?.total_gross_price?.toFixed(
                                      data?.currency?.value === "OMR" ? 3 : 2
                                    )}{" "}
                                    | {data?.order_products_count} items
                                  </p>
                                  <p className="text-black">
                                    Delivery to {data?.location?.name}
                                  </p>
                                </span>
                                <span className="text-sm text-main-two-600">
                                  <button
                                    key={data.id}
                                    className="btn btn-main d-inline-flex align-items-center gap-8 mt-24"
                                    type="button"
                                    onClick={() => handleRedirect(data.id)} // Pass the clicked ID
                                  >
                                    View order
                                  </button>
                                </span>
                              </div>
                              <hr></hr>
                              <div className="d-flex flex-wrap flex-md-nowrap w-100 gap-14 order-container">
                                <div className="d-flex justify-content-between w-100 w-md-50 p-16 bg-light-grey mb-32">
                                  <span className="text-sm text-white">
                                    <p className="text-black">Order Status</p>
                                    <p className="text-black">
                                      <b>
                                        Ordered{" "}
                                        {new Date(data?.created_at)
                                          .toLocaleDateString("en-GB")
                                          .replace(/\//g, ".")}
                                      </b>
                                    </p>
                                  </span>
                                  <span className="text-sm text-main-two-600">
                                    <p className="text-black">
                                      Preferred delivery date
                                    </p>
                                    <p className="text-black">
                                      {data?.preferred_delivery_date
                                        ? new Date(data.preferred_delivery_date)
                                            .toLocaleDateString("en-GB")
                                            .replace(/\//g, ".")
                                        : "-"}
                                    </p>
                                  </span>
                                </div>

                                <div className="d-flex justify-content-between w-100 w-md-50 p-16 bg-light-grey mb-32">
                                  <span className="text-sm text-white">
                                    <p className="text-black">Payment status</p>
                                    <p className="text-black">
                                      <b>{data?.payment_status}</b>
                                    </p>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                      </>
                    ))}
                </div>
                {/*  pagination for archive */}
                {archiveTotalPages > 1 && (
                  <div className="d-flex justify-content-center align-items-center mt-4">
                    <button
                      style={{
                        backgroundColor:
                          currentArchivePage > 1 ? "blue" : "#9db9e3",
                        color: "white",
                        padding: "0.5rem 1rem",
                        borderRadius: "0.25rem",
                        border: "none",
                        transition: "background-color 0.3s",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.backgroundColor = "blue")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.backgroundColor = "#9db9e3")
                      }
                      className="mx-1"
                      onClick={() =>
                        currentArchivePage > 1 &&
                        setCurrentArchivePage(currentArchivePage - 1)
                      }
                      disabled={currentArchivePage === 1}
                    >
                      Previous
                    </button>

                    {getArchivePageNumbers().map((page, idx) => {
                      const isActive = page === currentArchivePage;
                      return (
                        <button
                          key={idx}
                          style={{
                            backgroundColor: isActive ? "blue" : "#9db9e3",
                            color: "white",
                            padding: "0.5rem 1rem",
                            borderRadius: "0.25rem",
                            border: "none",
                            transition: "background-color 0.3s",
                          }}
                          onMouseEnter={
                            !isActive
                              ? (e) => (e.target.style.backgroundColor = "blue")
                              : undefined
                          }
                          onMouseLeave={
                            !isActive
                              ? (e) =>
                                  (e.target.style.backgroundColor = "#9db9e3")
                              : undefined
                          }
                          className="mx-1"
                          onClick={() => setCurrentArchivePage(page)}
                        >
                          {page}
                        </button>
                      );
                    })}

                    <button
                      style={{
                        backgroundColor:
                          currentArchivePage < archiveTotalPages
                            ? "blue"
                            : "#9db9e3",
                        //backgroundColor: "#9db9e3",
                        color: "white",
                        padding: "0.5rem 1rem",
                        borderRadius: "0.25rem",
                        border: "none",
                        transition: "background-color 0.3s",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.backgroundColor = "blue")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.backgroundColor = "#9db9e3")
                      }
                      className="mx-1"
                      onClick={() =>
                        currentArchivePage < archiveTotalPages &&
                        setCurrentArchivePage(currentArchivePage + 1)
                      }
                      disabled={currentArchivePage === archiveTotalPages}
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ActiveOrdersPage;
